import { Component, OnInit } from '@angular/core';
import {SolicitudService} from '../../../../../_services/solicitud.service';
import {NavService} from '../../../../../_services/_nav.service';
import {PlataformaDigitalService} from '../../../../../_services/plataforma-digital.service';

@Component({
  selector: 'app-widget-aprobacion-solicitudes',
  templateUrl: './widget-aprobacion-solicitudes.component.html',
  styleUrls: ['./widget-aprobacion-solicitudes.component.css']
})
export class WidgetAprobacionSolicitudesComponent implements OnInit {
  loading = true;
  contador: number;
  columnas: any[] = [];
  showModalSolicitudes = false;
  cargandoTabla = false;
  listSolicitudes: any[] = [];
  constructor(private solicitud: SolicitudService,
              private navServicio: NavService,
              private plataformaDigital: PlataformaDigitalService) { }

  ngOnInit() {
    this.contador = 0;
    this.loading = false;
    this.cargarContador();
    this.columnas = [
      { field: 'idSolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NUMEROSOLICITUD' ), sort: true, check: false },
      { field: 'fechaSolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_FECHASOLICITUD' ), sort: true, check: false },
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_DOCUMENTO' ), sort: true, check: false },
      { field: 'nombres', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NOMBRES' ), sort: false, check: true },
      { field: 'estadoActual', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_ESTADO' ), sort: false, check: false },
      { field: 'fechaAnulacion', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_FECHACANCELACION' ), sort: false, check: false },
      { field: 'causaul', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_CAUSAL' ), sort: false, check: false },
      { field: 'observacion', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_OBSERVACION' ), sort: false, check: false },
      { field: 'observacion', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false, check: false }
    ];
  }

  async cargarContador() {
    const pendientes = await this.solicitud.contadorPendienteAprobacion().toPromise();
    this.contador = pendientes;
  }

  cargarSolicitudes() {
    this.cargandoTabla = true;
    this.plataformaDigital.listaSolicitudes().subscribe(lista => {
      this.listSolicitudes = lista;
      this.showModalSolicitudes = true;
      this.cargandoTabla = false;
    }, error => {
      this.cargandoTabla = false;
      this.navServicio.setMesage(0, {
        severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
      });
    });
  }

  cambioEstado(row: any , indicador: boolean) {
    const objAnulacion = {} as any;
    objAnulacion.idPlataformaDigital = row.idPlataformaDigital;
    objAnulacion.indicadorPendienteAprobacion = indicador;
    this.plataformaDigital.cambioEstadoAnulacion(objAnulacion).subscribe(res => {
      this.cargarSolicitudes();
    });
  }

}
